import React, { Component } from 'react';
import { connect } from 'react-redux'
import history from '../history';
import {userExpirySession} from '../actions/login'
import Cookies from 'universal-cookie';
import ProductPackageConfiguration from './components/products/rpp/productPackageConfiguration'
import CommercialProductPackageConfiguration from './components/products/commercial/commercialProductPackageConfiguration'
import CordellConnectProductPackageConfiguration from './components/products/cordellConnect/cordellConnectProductPackageConfiguration'
import CordellEstimatorProductPackageConfiguration from './components/products/cordellEstimator/cordellEstimatorProductPackageConfiguration'
import ReportBundleProductPackageConfiguration from './components/products/reportBundle/reportBundleProductPackageConfiguration'
import ProductConfigSummary from './components/productConfigSummary'

import {fetchQuote, fetchFilteredAreas, fetchSuburbList} from '../actions/packageConfiguration'
import {saveCartItem,deleteOrder, fetchCart, getUserSession, checkout} from '../actions/cart'
import {getContactInfo, getContactUsername} from '../actions/checkout'

import { verifyEmailValidated } from '../services/v2/customerRegistration/registrationService';
import { isStatesMissing } from '../utils/helpers';

class PackageConfiguration extends Component {
  constructor(props) {
    super(props);

    this.onSelectingUser = this.onSelectingUser.bind(this);
    this.onSelectingAddons = this.onSelectingAddons.bind(this);
    this.onRemoveAddon = this.onRemoveAddon.bind(this);
    this.onSelectingGeography = this.onSelectingGeography.bind(this);
    this.onAddToCart = this.onAddToCart.bind(this);

    this.onSelectingCommercialGeography = this.onSelectingCommercialGeography.bind(this);
    this.onRemoveCommercialGeographyPackage = this.onRemoveCommercialGeographyPackage.bind(this);

    this.onSelectingCordellGeography = this.onSelectingCordellGeography.bind(this);
    this.onSelectingCordellUser = this.onSelectingCordellUser.bind(this);
    this.onCordellTrialUser = this.onCordellTrialUser.bind(this);

    this.onSelectingReportBundleGeography = this.onSelectingReportBundleGeography.bind(this);

    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.onCouncilSelect = this.onCouncilSelect.bind(this);
    this.onDeselectCouncil = this.onDeselectCouncil.bind(this);
    this.getSuburbList = this.getSuburbList.bind(this);

    this.setConfigurationBlob = this.setConfigurationBlob.bind(this);
    this.setCategory = this.setCategory.bind(this);

    this.checkProductConfigWizard = this.props.ProductsService.checkProductConfigWizard.bind(this);
    this.getIncompleteProductIds = this.props.ProductsService.getIncompleteProductIds.bind(this);
    this.isGeoValidationRequired = this.props.ProductsService.isGeoValidationRequired.bind(this);
    this.productSwitch = this.props.ProductsService.productSwitch.bind(this);

    this.changePackage = this.changePackage.bind(this);
    this.onCheckout = this.onCheckout.bind(this);

    //SERVICES
    this.analyticsPageView = this.props.SegmentAnalytics.analyticsPageView.bind(this);
    this.trackGenericPageInfo = this.props.SegmentAnalytics.trackGenericPageInfo.bind(this);
    this.trackAddToCart = this.props.SegmentAnalytics.trackAddToCart.bind(this);
    this.setCustomerDetails = this.props.OrderService.setCustomerDetails.bind(this);
    this.trackError = this.props.SegmentAnalytics.trackError.bind(this);

    this.state = {
      configuration: {},
      friendlyName: null,
      errorMessage: null
    };
  }

  getFriendlyName(productId, productsConfig) {
    let friendlyName = null;

    for (let config in productsConfig) {
      if (productsConfig[config].id === parseInt(productId, 10)) {
        friendlyName = productsConfig[config].productUrl;
        break;
      }
    }

    return friendlyName;
  }

  setConfigurationBlob(productId = null, productsConfig = null) {
    let product_id = productId ? productId : this.props.match.params.product_id;
    let products_config = productsConfig
      ? productsConfig
      : this.props.productPackage.productsConfig[this.state.friendlyName];

    let quoteConfig = products_config.quoteConfigurationTemplate.configuration;
    // Checks if the config for the quotes persists and sets them accordingly
    // Conditions to get configuration from redux for persistent data
    if (
      // Check for RPP on industry
      (!quoteConfig.industry && products_config.quoteServiceType === 'RPPRealEstate') ||
      // Check product on package
      (!quoteConfig.package &&
        products_config.quoteServiceType !== 'CordellEstimator' &&
        products_config.quoteServiceType !== 'ReportBundle') ||
      // Check product on packageName
      (!quoteConfig.packageName &&
        (products_config.quoteServiceType === 'CordellEstimator' ||
          products_config.quoteServiceType === 'ReportBundle')) ||
      // Check for Investor Premium
      (quoteConfig.packageName &&
        quoteConfig.packageName === 'investors_premium' &&
        this.props.productQuote.quoteById[8] &&
        products_config.quoteServiceType === 'ReportBundle')
    ) {
      return this.props.productQuote.quotesConfigById[product_id];
    } else {
      if (quoteConfig.industry === 'real_estate_agencies_and_valuers') {
        let industryKey = quoteConfig.industry;
        let packageKey = quoteConfig.package;
        quoteConfig.geography.national =
          products_config.configuration.industries[industryKey].packages[
            packageKey
          ].geography.national;
        return products_config.quoteConfigurationTemplate;
      } else {
        return products_config.quoteConfigurationTemplate;
      }
    }
  }

  setCategory(categoryKey) {
    let configurationBlob = this.setConfigurationBlob();
    configurationBlob.configuration.category[categoryKey] =
      !configurationBlob.configuration.category[categoryKey];
    configurationBlob.product_id = parseInt(this.props.match.params.product_id, 10);
    this.props.fetchQuote(configurationBlob, this.props.match.params.product_id);
  }

  onSelectingUser(user) {
    let configurationBlob = this.setConfigurationBlob();

    if (configurationBlob.configuration.number_of_users !== undefined) {
      configurationBlob.configuration.number_of_users = user;
    } else if (configurationBlob.configuration.numberOfUsers !== undefined) {
      configurationBlob.configuration.numberOfUsers = user;
    }

    configurationBlob.product_id = parseInt(this.props.match.params.product_id, 10);
    this.props.fetchQuote(configurationBlob, this.props.match.params.product_id);
  }

  onSelectingAddons(addon) {
    let productsConfig = this.props.productPackage.productsConfig[this.state.friendlyName];
    let productId = this.props.match.params.product_id;
    let configurationBlob = this.setConfigurationBlob(productId, productsConfig);
    if (productsConfig.quoteServiceType === 'RPPRealEstate') {
      if (configurationBlob.configuration.number_of_users == null) {
        let industryKey = configurationBlob.industry;
        let packageKey = configurationBlob.package;
        configurationBlob.configuration.number_of_users = parseInt(
          productsConfig.configuration.industries[industryKey].packages[packageKey].users.min_users,
          10
        );
      }
    }
    let index = configurationBlob.configuration.addons.indexOf(addon.name);
    if (index === -1) {
      configurationBlob.configuration.addons.push(addon.name);
    } else {
      configurationBlob.configuration.addons.splice(index, 1);
    }
    configurationBlob.product_id = parseInt(productId, 10);
    this.props.fetchQuote(configurationBlob, productId);
  }

  onRemoveAddon(addon) {
    let configurationBlob = this.setConfigurationBlob();
    let index = configurationBlob.configuration.addons.indexOf(addon);
    if (index > -1) {
      configurationBlob.configuration.addons.splice(index, 1);
    }
    configurationBlob.product_id = parseInt(this.props.match.params.product_id, 10);
    this.props.fetchQuote(configurationBlob, this.props.match.params.product_id);
  }

  onSelectingGeography(states, national) {
    let productId = this.props.match.params.product_id;
    let configurationBlob = this.setConfigurationBlob(productId, null);
    if (
      this.props.productPackage.productsConfig[this.state.friendlyName].quoteServiceType ===
      'RPPRealEstate'
    ) {
      let industryKey = configurationBlob.configuration.industry;
      let packageKey = configurationBlob.configuration.package;
      if (configurationBlob.configuration.number_of_users == null) {
        configurationBlob.configuration.number_of_users = parseInt(
          this.props.productPackage.productsConfig[this.state.friendlyName].configuration
            .industries[industryKey].packages[packageKey].users.min_users,
          10
        );
      }

      if (configurationBlob.configuration.industry === 'real_estate_agencies_and_valuers') {
        configurationBlob.configuration.geography.states =
          this.props.productPackage.productsConfig[
            this.state.friendlyName
          ].configuration.industries[industryKey].packages[packageKey].geography.states;
        configurationBlob.configuration.geography.national =
          this.props.productPackage.productsConfig[
            this.state.friendlyName
          ].configuration.industries[industryKey].packages[packageKey].geography.national;
      }
    }
    configurationBlob.configuration.geography.states = states;
    configurationBlob.configuration.geography.national = national;
    configurationBlob.product_id = parseInt(productId, 10);
    this.props.fetchQuote(configurationBlob, productId);
    this.setState({
      errorMessage: null
    });
  }

  onSelectingCommercialGeography(area, users) {
    let configurationBlob = [];
    let packages = {};
    if (users != null && Object.keys(area).length > 0 && area.city != null && area.state != null) {
      configurationBlob = this.setConfigurationBlob();
      packages = {
        package: configurationBlob.configuration.package,
        number_of_users: users,
        location: area,
        addons: []
      };
      if (configurationBlob) {
        configurationBlob.configuration.packages.push(packages);
        configurationBlob.product_id = parseInt(this.props.match.params.product_id, 10);
        this.props.fetchQuote(configurationBlob, this.props.match.params.product_id);
      }

      this.setState({
        errorMessage: null
      });
    } else {
      this.setState(
        {
          errorMessage: 'Please select the city and users'
        },
        () => {
          this.trackError('Select Commercial Geography', null, this.state.errorMessage, null);
        }
      );
    }
  }

  onRemoveCommercialGeographyPackage(lineItem, index) {
    let configurationBlob = this.setConfigurationBlob();

    if (index > -1) {
      let isCommercialCombo = this.state.friendlyName &&
        this.props.productPackage.productsConfig.commercial.quoteConfigurationTemplate.configuration.package  === 'combo'
      if ( isCommercialCombo ) {
        if( index == 0) configurationBlob.configuration.packages.splice(index/2, 1);
        else configurationBlob.configuration.packages.splice(index/2-1, 1)
      }
      else {
        if( index ==0 )configurationBlob.configuration.packages.splice(index, 1);
        else configurationBlob.configuration.packages.splice(index-1, 1);
      }
    }
    configurationBlob.product_id = parseInt(this.props.match.params.product_id, 10);

    this.props.fetchQuote(configurationBlob, this.props.match.params.product_id);
  }

  onCheckout() {
    this.props.getUserSession().then(
      function () {
        if (this.props.loggedIn || this.props.login.userLoggedIn) {
          this.setCustomerDetails();
        } else {
          history.push('/register');
        }
      }.bind(this)
    );
  }

  trackAddItemToCartAnalytics(action, quote) {
    let cta = action === 'buy' ? 'Buy it Now' : 'Add to Cart';
    this.trackAddToCart(cta, quote);
  }

  onAddToCart(action) {
    let productsConfig = this.props.productPackage.productsConfig[this.state.friendlyName];
    let productId = this.props.match.params.product_id;
    let configurationBlob = this.setConfigurationBlob(productId, productsConfig);

    let cta = action === 'buy' ? 'Buy it Now' : 'Add to Cart';

    if (isStatesMissing(productsConfig.quoteServiceType, configurationBlob.configuration)) {
      this.setState(
        {
          errorMessage: 'Please select the zone'
        },
        () => {
          this.trackError(cta, null, this.state.errorMessage, null);
        }
      );
      return;
    }

    //Segment Analytics
    this.trackAddItemToCartAnalytics(action, this.props.productQuote.quoteById[productId]);

    let cartItem = {
      configuration: configurationBlob.configuration,
      product_id: parseInt(productId, 10)
    };

    const afterSaveCartItem = function () {
      let productIds = this.getIncompleteProductIds();
      if (productIds.length > 0) {
        history.push(`/product_config/${productIds[0]}`);
      } else {
        if (action === 'buy') {
          this.onCheckout();
        }
      }
    }.bind(this);

    if (this.props.order != null && Object.keys(this.props.order).length > 0) {
      this.props.deleteOrder(cartItem).then(
        function () {
          this.props.saveCartItem(cartItem, action).then(afterSaveCartItem);
        }.bind(this)
      );
    } else {
      this.props.saveCartItem(cartItem, action).then(afterSaveCartItem);
    }
    this.setState({
      errorMessage: null
    });
  }

  onSelectingCordellGeography(geography) {
    let configurationBlob = this.setConfigurationBlob();
    configurationBlob.configuration.geography = geography;
    if (configurationBlob.configuration.number_of_users === null) {
      configurationBlob.configuration.number_of_users = 1;
    }
    if (configurationBlob.configuration.package === 'lite') {
      configurationBlob.configuration.number_of_users = 2;
    }
    configurationBlob.product_id = parseInt(this.props.match.params.product_id, 10);
    this.props.fetchQuote(configurationBlob, this.props.match.params.product_id);
    this.setState({
      errorMessage: null
    });
  }

  onSelectingCordellUser(user) {
    let configurationBlob = this.setConfigurationBlob();
    configurationBlob.configuration.number_of_users = user;
    configurationBlob.product_id = parseInt(this.props.match.params.product_id, 10);
    this.props.fetchQuote(configurationBlob, this.props.match.params.product_id);
  }

  onCordellTrialUser() {
    let configurationBlob = this.setConfigurationBlob();
    configurationBlob.configuration.number_of_users = 1;
    configurationBlob.configuration.geography.states = null;
    configurationBlob.configuration.geography.state_type = 'limited';
    configurationBlob.product_id = parseInt(this.props.match.params.product_id, 10);
    this.props.fetchQuote(configurationBlob, this.props.match.params.product_id);
  }

  onSelectingReportBundleGeography(state) {
    let configurationBlob = this.setConfigurationBlob();
    configurationBlob.configuration.geography.states = state;
    configurationBlob.product_id = parseInt(this.props.match.params.product_id, 10);
    this.props.fetchQuote(configurationBlob, this.props.match.params.product_id);
    this.setState({
      errorMessage: null
    });
  }

  changePackage() {
    this.trackGenericPageInfo('Back to package selection page');
    if (this.state.friendlyName == 'rp-data-professional') {
      history.push(`/product/rp-data-professional`);
    }  else {
      history.push(`/product/${this.state.friendlyName}`);
    }
  }

  onSearchInputChange(event) {
    if (event.target.value !== null && event.target.value !== '' && event.target.value.length > 2) {
      this.props.fetchFilteredAreas(event.target.value);
    }
  }

  onCouncilSelect(council) {
    this.setState({
      errorMessage: null
    });
    let configurationBlob = this.setConfigurationBlob();
    for (let i = 0; i < configurationBlob.configuration.geography.councils.length; i++) {
      if (configurationBlob.configuration.geography.councils[i] === `${council} Council`) {
        this.setState(
          {
            errorMessage: 'You have already selected this council'
          },
          () => {
            this.trackError('Council Select', null, this.state.errorMessage, null);
          }
        );
        return;
      }
    }
    configurationBlob.configuration.geography.councils.push(`${council} Council`);
    configurationBlob.product_id = parseInt(this.props.match.params.product_id, 10);
    if (configurationBlob.configuration.number_of_users === null) {
      configurationBlob.configuration.number_of_users = 1;
    }
    this.props.fetchQuote(configurationBlob, this.props.match.params.product_id);
    document.body.style.zoom = '100%';
  }

  onDeselectCouncil(council) {
    this.setState({
      errorMessage: null
    });
    let configurationBlob = this.setConfigurationBlob();
    for (let i = 0; i < configurationBlob.configuration.geography.councils.length; i++) {
      if (configurationBlob.configuration.geography.councils[i] === council) {
        configurationBlob.configuration.geography.councils.splice(i, 1);
      }
    }
    configurationBlob.product_id = parseInt(this.props.match.params.product_id, 10);
    if (configurationBlob.configuration.number_of_users === null) {
      configurationBlob.configuration.number_of_users = 1;
    }
    this.props.fetchQuote(configurationBlob, this.props.match.params.product_id);
  }

  getSuburbList(council) {
    this.props.fetchSuburbList(council);
  }

  componentDidMount() {
    this.analyticsPageView('Customisation');
    this.props.userExpirySession();
    const cookies = new Cookies();
    let productId = this.props.match.params.product_id;
    let productsConfig = this.props.productPackage.productsConfig;
    let friendlyName = this.getFriendlyName(productId, productsConfig);

    this.setState(
      {
        friendlyName: friendlyName
      },
      () => {
        if (productsConfig[this.state.friendlyName]) {
          let configurationBlob = this.setConfigurationBlob(
            productId,
            productsConfig[this.state.friendlyName]
          );
          if (productsConfig[this.state.friendlyName].quoteServiceType === 'RPPRealEstate') {
            if (configurationBlob.configuration.number_of_users == null) {
              let users =
                productsConfig[this.state.friendlyName].configuration.industries[
                  configurationBlob.configuration.industry
                ].packages[configurationBlob.configuration.package].users;
              configurationBlob.configuration.number_of_users = parseInt(
                users.min_users ? users.min_users : users.default_users,
                10
              );
            }
            configurationBlob.product_id = parseInt(productId, 10);
            this.props.fetchQuote(configurationBlob, productId);
            // this.setState({
            //   configuration: productsConfig[productId].defaultConfig
            // })

            if (configurationBlob.configuration.industry) {
              cookies.set('industry', configurationBlob.configuration.industry);
            } else {
              cookies.remove('industry');
            }
          } else if (
            productsConfig[this.state.friendlyName].quoteServiceType === 'Commercial' ||
            productsConfig[this.state.friendlyName].quoteServiceType === 'CordellConnect'
          ) {
            configurationBlob.product_id = parseInt(productId, 10);
            this.props.fetchQuote(configurationBlob, productId);
          } else if (
            productsConfig[this.state.friendlyName].quoteServiceType === 'CordellEstimator'
          ) {
            if (configurationBlob.configuration.numberOfUsers === null) {
              configurationBlob.configuration.numberOfUsers = 1;
            }
            configurationBlob.product_id = parseInt(productId, 10);
            this.props.fetchQuote(configurationBlob, productId);
          }
        } else {
          history.push('/cart');
        }
      }
    );

    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    const productId = this.props.match.params.product_id;
    const productsConfig = this.props.productPackage.productsConfig;
    const friendlyName = this.getFriendlyName(productId, productsConfig);

    if (friendlyName !== this.state.friendlyName) {
      this.setState({
        friendlyName: friendlyName
      });
    }

    if (prevProps.checkoutErrors !== this.props.checkoutErrors) {
      const options = {
        history: history,
        prevCheckoutErrors: prevProps.checkoutErrors,
        checkoutErrors: this.props.checkoutErrors
      };
      verifyEmailValidated(options);
    }
  }

  render(props) {
    let productId = this.props.match.params.product_id;
    let productsConfig = this.props.productPackage.productsConfig[this.state.friendlyName];
    let isCommercialCombo = this.state.friendlyName == 'commercial' &&
      this.props.productPackage.productsConfig.commercial.quoteConfigurationTemplate.configuration.package == 'combo'
    return (
      <div className='off-white-bg'>
        <div className='container'>
          {productsConfig && (
            <div className='row row-eq-height margin-bottom-100'>
              <div className='col-sm-8'>
                {productsConfig.quoteServiceType === 'RPPRealEstate' && (
                  <ProductPackageConfiguration
                    productPackageConfig={productsConfig.configuration}
                    productPackageDefaultConfig={this.setConfigurationBlob(
                      productId,
                      productsConfig
                    )}
                    onSelectingUser={this.onSelectingUser}
                    onSelectingAddons={this.onSelectingAddons}
                    onSelectingGeography={this.onSelectingGeography}
                    coupon={this.props.coupon}
                  />
                )}
                {productsConfig.quoteServiceType === 'Commercial' && (
                  <CommercialProductPackageConfiguration
                    isCommercialCombo={isCommercialCombo}
                    onRemoveCommercialGeographyPackage={this.onRemoveCommercialGeographyPackage}
                    productQuote={this.props.productQuote.quoteById[productId]}
                    productPackageConfig={productsConfig.configuration}
                    productPackageDefaultConfig={this.setConfigurationBlob(
                      productId,
                      productsConfig
                    )}
                    onSelectingCommercialGeography={this.onSelectingCommercialGeography}
                  />
                )}
                {productsConfig.quoteServiceType === 'CordellConnect' && (
                  <CordellConnectProductPackageConfiguration
                    productPackageConfig={productsConfig.configuration}
                    productPackageDefaultConfig={this.setConfigurationBlob(
                      productId,
                      productsConfig
                    )}
                    packageKey={
                      this.setConfigurationBlob(productId, productsConfig).configuration.package
                    }
                    onSelectingCordellGeography={this.onSelectingCordellGeography}
                    onSelectingCordellUser={this.onSelectingCordellUser}
                    onCordellTrialUser={this.onCordellTrialUser}
                    onSearchInputChange={this.onSearchInputChange}
                    filteredAreas={this.props.filteredAreas}
                    onCouncilSelect={this.onCouncilSelect}
                    areaLoading={this.props.areaLoading}
                    onDeselectCouncil={this.onDeselectCouncil}
                    getSuburbList={this.getSuburbList}
                    suburbList={this.props.suburbList}
                  />
                )}
                {productsConfig.quoteServiceType === 'CordellEstimator' && (
                  <CordellEstimatorProductPackageConfiguration
                    productPackageConfig={productsConfig.configuration}
                    productPackageDefaultConfig={this.setConfigurationBlob(
                      productId,
                      productsConfig
                    )}
                    packageKey={
                      this.setConfigurationBlob(productId, productsConfig).configuration.packageName
                    }
                    onSelectingUser={this.onSelectingUser}
                    setCategory={this.setCategory}
                    onSelectingGeography={this.onSelectingGeography}
                    onSelectingAddons={this.onSelectingAddons}
                  />
                )}
                {productsConfig.quoteServiceType === 'ReportBundle' && (
                  <ReportBundleProductPackageConfiguration
                    productPackageConfig={productsConfig.configuration}
                    productPackageDefaultConfig={this.setConfigurationBlob(
                      productId,
                      productsConfig
                    )}
                    onSelectingReportBundleGeography={this.onSelectingReportBundleGeography}
                  />
                )}
              </div>
              <div className='col-sm-4'>
                <ProductConfigSummary
                  productQuote={this.props.productQuote.quoteById[productId]}
                  productsConfig={productsConfig}
                  productPackageDefaultConfig={this.setConfigurationBlob(productId, productsConfig)}
                  onRemoveAddon={this.onRemoveAddon}
                  onAddToCart={this.onAddToCart}
                  agent={this.props.agent}
                  loading={this.props.loading}
                  quoteLoading={this.props.quoteLoading}
                  onRemoveCommercialGeographyPackage={this.onRemoveCommercialGeographyPackage}
                  coupon={this.props.coupon}
                  changePackage={this.changePackage}
                  cart={this.props.cart}
                  onDeselectCouncil={this.onDeselectCouncil}
                  errorMessage={this.state.errorMessage}
                  checkProductConfigWizard={this.checkProductConfigWizard}
                  contactsLoader={this.props.contactsLoader}
                  selectedIndustry={this.props.selectedIndustry}
                  selectedPackage={this.props.selectedPackage}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    productPackage: state.packageSelection,
    productQuote: state.packageConfiguration,
    filteredAreas: state.packageConfiguration.filteredAreas,
    suburbList: state.packageConfiguration.suburbList,
    areaLoading: state.packageConfiguration.areaLoading,
    cart: state.cart.cart,
    order: state.cart.order,
    agent: state.packageSelection.agent,
    coupon: state.packageSelection.coupon,
    loading: state.cart.loading,
    quoteLoading: state.packageConfiguration.loading,
    loggedIn: state.cart.loggedIn,
    login: state.login,
    contactInfo: state.checkout.contactInfo,
    contactUsernameDetails: state.checkout.contactUsernameDetails,
    registration: state.registration,
    method: state.packageSelection.method,
    contactsLoader: state.checkout.contactsLoader,
    selectedIndustry: state.packageSelection.selectedIndustry,
    selectedPackage: state.packageSelection.selectedPackage,
    checkoutErrors: state.cart.checkoutErrors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchQuote: (configuration, productId) => dispatch(fetchQuote(configuration, productId)),
    fetchFilteredAreas: (searchText) => dispatch(fetchFilteredAreas(searchText)),
    fetchSuburbList: (council) => dispatch(fetchSuburbList(council)),
    saveCartItem: (cartItem, action) => dispatch(saveCartItem(cartItem, action)),
    deleteOrder: (item) => dispatch(deleteOrder(item)),
    fetchCart: () => dispatch(fetchCart()),
    getUserSession: () => dispatch(getUserSession()),
    userExpirySession: () => dispatch(userExpirySession()),
    getContactInfo: () => dispatch(getContactInfo()),
    getContactUsername: (accountGuid) => dispatch(getContactUsername(accountGuid)),
    checkout: (order) => dispatch(checkout(order))
  };
};

let PackageConfigurationPage = connect(mapStateToProps, mapDispatchToProps)(PackageConfiguration);

export default PackageConfigurationPage;
